<span>
{{ application.created | isoDate }} -
  {{ application.caseName }} - {{ application.purpose | applicationPurpose }} -
  {{ application.status | applicationStatus }}
  </span>